import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "hotel/commerce/";

class CommerceService {
  getProviders() {
    return axios.get(ENDPOINT_URL + "providers", { headers: authHeader() });
  }

  getConnectionOptions(provider) {
    return axios.get(ENDPOINT_URL + `providers/${provider}/options`, {
      headers: authHeader(),
    });
  }

  getConnections() {
    return axios.get(ENDPOINT_URL + "connections", {
      headers: authHeader(),
    });
  }

  createConnection(connection) {
    return axios.post(ENDPOINT_URL + "connections", connection, {
      headers: authHeader(),
    });
  }

  syncConnection(connectionId) {
    return axios.post(
      ENDPOINT_URL + `connections/${connectionId}/sync`,
      {},
      { headers: authHeader() },
    );
  }

  setConnectionEnabled(connectionId, enabled) {
    return axios.patch(
      ENDPOINT_URL + `connections/${connectionId}`,
      { enabled },
      { headers: authHeader() },
    );
  }

  setActivationMode(connectionId, activationMode) {
    return axios.patch(
      ENDPOINT_URL + `connections/${connectionId}`,
      { activationMode },
      { headers: authHeader() },
    );
  }

  deleteConnection(connectionId) {
    return axios.delete(ENDPOINT_URL + `connections/${connectionId}`, {
      headers: authHeader(),
    });
  }

  getCatalog() {
    return axios.get(ENDPOINT_URL + "catalog", { headers: authHeader() });
  }
}

export default new CommerceService();
